export default class LongGridInitConfig {
  constructor ({ defaultParameters }) {
    this.defaultParameters = defaultParameters
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/LongGridInitConfig.js